/*
  rv-inside.js: the scoop video in "What's inside one scoop" (sections/rv-inside.liquid, Cris 2026-10-04).
  <rv-inside-video data-sd data-hd> holds a lazy poster <img>, a muted looping <video> with no src, and a pause/play
  button. The video loads only when the section nears the screen (the SD file on phones under 750px or with
  Save-Data, else 720p), plays while on screen and pauses off screen. Reduced motion: it never starts on its own; the
  button plays it. A tap on the button wins over both (WCAG 2.2.2). Without JS the poster image is the view.
*/
(() => {
  if (customElements.get('rv-inside-video')) return;

  class RvInsideVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.btn = this.querySelector('.rv-inside__vbtn');
      if (!this.video || !this.btn) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.choice = null; // 'play' | 'pause' once the visitor taps the button
      this.visible = false;
      this.onClick = () => {
        this.choice = this.video.paused ? 'play' : 'pause';
        this.sync();
      };
      this.btn.addEventListener('click', this.onClick);
      this.btn.hidden = false;
      this.label(false);
      this.io = new IntersectionObserver((entries) => {
        this.visible = entries.some((e) => e.isIntersecting);
        this.sync();
      }, { rootMargin: '150px 0px' });
      this.io.observe(this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.btn && this.onClick) this.btn.removeEventListener('click', this.onClick);
    }

    wants() {
      if (this.choice) return this.choice === 'play';
      return !this.motion.matches;
    }

    load() {
      if (this.video.getAttribute('src')) return;
      const save = navigator.connection && navigator.connection.saveData;
      const small = window.innerWidth < 750;
      this.video.src = (save || small ? this.dataset.sd : this.dataset.hd) || this.dataset.hd;
    }

    sync() {
      if (this.visible && this.wants()) {
        this.load();
        const p = this.video.play();
        if (p && p.then) {
          p.then(() => {
            this.classList.add('is-playing');
            this.label(true);
          }).catch(() => this.label(false));
        }
      } else if (!this.video.paused) {
        this.video.pause();
        this.label(false);
      }
    }

    label(playing) {
      this.btn.classList.toggle('is-playing', playing);
      this.btn.setAttribute('aria-label', playing ? this.btn.dataset.labelPause : this.btn.dataset.labelPlay);
    }
  }

  customElements.define('rv-inside-video', RvInsideVideo);
})();
